export const greyColor = "#9e9e9e";
export const lightOrange = "#ff6f61";
export const bgGrey = "#f6f6f6";
//
